module.exports = __webpack_public_path__ + "media/icons/material-icon-chevron-left-28a10b5c.png";